
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Tab, Nav, Col, Badge } from 'react-bootstrap';
import { Filter, FilterBox } from '../widgets';

const EquipmentGroupFilter = (props) => {
  const defaultProps = {
    crew: [],
    category: []
  };
  const initialState = {
    ...defaultProps,
    isOpen: false,
    filters: { ...defaultProps },
    previous: { ...defaultProps }
  }

  const equipmentGroupList = useSelector(state => state.equipmentGroup.equipmentGroupList);
  // const crewList = useSelector(state => state.crew.crewList);
  const selectedPlanType = useSelector(state => state.plan.selectedPlanType);
  const [state, setState] = useState(initialState);

  const { onFilter } = props;

  const bindOptions = () => {
    const egList = equipmentGroupList;
    const crew = {}, category = {};

    for (const item of egList) {
      const crewId = item.crew.crew_uuid ? item.crew.crew_uuid : -1;
      if (crew[crewId] || item.plan_type_id !== selectedPlanType) continue;
      if (crewId !== -1) crew[crewId] = { name: item.crew.name };
      else crew[crewId] = { name: "Unknown" };
    }

    for (const item of egList) {
      const name = item.primary_category_name;
      if (!name || category[name]) continue;
      category[name] = { id: item.primary_category_id };
    }

    setState({
      ...state,
      crew: Object.keys(crew).map(id => ({ id, ...crew[id] })),
      category: Object.keys(category).map(name => ({ name, ...category[name] }))
    });
  }

  const handleSelect = (item, e, name) => {
    const id = (name === 'category') ? item.name : item.id;
    const { checked } = e.target;
    const selected = [...state.filters[name]];
    const indexOf = selected.indexOf(id);
    if (checked && indexOf < 0) selected.push(id);
    else if (!checked && indexOf >= 0) selected.splice(indexOf, 1);
    setState({ ...state, filters: { ...state.filters, [name]: selected } });
  }

  const handleApply = () => {
    const { filters } = state;
    let foundItems = equipmentGroupList;

    if (filters.crew.length > 0)
      foundItems = foundItems.filter(e => filters.crew.indexOf(e.crew.crew_uuid ? e.crew.crew_uuid : "-1") >= 0);

    if (filters.category.length > 0)
      foundItems = foundItems.filter(e => filters.category.indexOf(e.primary_category_name) >= 0);

    onFilter(foundItems.map(e => e.equipment_group_uuid));
    setState({ ...state, isOpen: false, previous: state.filters });
  }

  const handleClear = () => {
    onFilter(null);
    setState({ ...state, filters: { ...defaultProps }, previous: { ...defaultProps } });
  }

  const toggle = (isOpen) => {
    if (!isOpen && state.isOpen)
      setState({ ...state, isOpen, filters: { ...state.previous } });
    else setState({ ...state, isOpen });
  }

  const getFilterCount = (name) => {
    if (name)
      return state.filters && state.filters[name] && state.filters[name].length > 0 ? state.filters && state.filters[name] && state.filters[name].length : '';
    else {
      let total = 0;
      for (const key in state.filters) total += (state.filters[key].length > 0 ? 1 : 0);
      return total > 0 ? total : null;
    }
  }

  useEffect(() => {
    bindOptions();
  }, []);

  useEffect(() => {
    bindOptions();
  }, [equipmentGroupList])

  const totalFilters = getFilterCount();
  return (
    <Filter show={state.isOpen} onToggle={toggle}>
      <Filter.Toggle>
        {totalFilters && <Badge variant="warning" className="badge-filter-count">{totalFilters}</Badge>}
      </Filter.Toggle>
      <FilterBox>
        <Tab.Container defaultActiveKey="first">
          <FilterBox.Body>
            <Col sm={5} className="mt-2 pr-1">
              <Nav variant="pills" className="flex-column">
                <Nav.Item>
                  <Nav.Link eventKey="first">
                    Crew
                    <span className="filter-count">{getFilterCount("crew")}</span>
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="second">
                    Category
                    <span className="filter-count">{getFilterCount("category")}</span>
                  </Nav.Link>
                </Nav.Item>
              </Nav>
            </Col>
            <Col lg={7}>
              <Tab.Content>
                <Tab.Pane eventKey="first">
                  <Filter.Options options={state.crew} selected={state.filters && state.filters.crew}
                    keyname={{ value: "id", label: "name" }}
                    onSelect={(item, e) => handleSelect(item, e, "crew")} />
                </Tab.Pane>
                <Tab.Pane eventKey="second">
                  <Filter.Options options={state.category} selected={state.filters && state.filters.category}
                    keyname={{ value: "name", label: "name" }}
                    onSelect={(item, e) => handleSelect(item, e, "category")} />
                </Tab.Pane>
              </Tab.Content>
            </Col>
          </FilterBox.Body>
          <FilterBox.Footer>
            <Filter.ClearButton onClick={handleClear} />
            <Filter.ApplyButton onClick={handleApply} />
          </FilterBox.Footer>
        </Tab.Container>
      </FilterBox>
    </Filter>
  );
}

export default EquipmentGroupFilter;